import moment from 'moment-timezone';
export function getPresentedEnglishType(type) {
    switch(type){
        case 'en-gb': 
            return 'GB';
        case 'en-au': 
            return 'AU';
        case 'en-us':
            return 'US';
        case 'en-ca': 
        default:
            return 'CA';
    }
}

export function getFormattedTime(time) {
    return time;
    // old code that was supposed to fix different DB formatting.
    // server side fixed, so no more need to try and re-format in client side.
    if(time === null) {
        return "";
    }
    //moment.globalTimezone = 'America/New_York';
    var res = moment(time).tz('America/New_York').format("MM/DD/YYYY hh:mm A");
    if(res == 'Invalid date') {
        res = moment(time, 'hh:mm DD/MM/YYYY').tz('America/New_York').format("MM/DD/YYYY hh:mm A"); 
    }
    if(res == 'Invalid date') {
        console.log(time+" still bad - rendering DB value");
        res = time;
    }
    return res + " EST";
}

export function docStatusToString(status) {
    // editors evaluating edit, edit in progress, complete, unedited
    switch(status) {
        case 0: return 'unpaid';
        case 1: return 'editors evaluating edit';
        case 2: return 'edit in progress';
        case 3: return 'complete';
        case 4: return 'unedited'; // is that "expired"? this is what the BE does on expiry

    }
}
export function hasEsl(extras, eslType) {
    if(!extras) { return false; }
    var extrasArr = JSON.parse(extras);
    if(extrasArr.length == 0) {
      return false;
    }
    for(var i in extrasArr) {
      if(extrasArr[i] == eslType) {
        return true;
      }
    }
    return false;
}

const levels = { 
    'pro': 4,
    'gold': 3,
    'silver': 2,
    'bronze': 1
}
export function editorLessThanOrEqual(level1, level2) {
    return (levels[level1] <= levels[level2]);
}
export function editorLessThan(level1, level2) {
    return (levels[level1] < levels[level2]);
}

export function isTinyDocument(word_count) {
    if(word_count <= 1300) return true;
    return false;
}

export function isSmallDocument(word_count) {
    if(word_count <= 2275 && word_count > 1300) return true;
    return false;
}

export function isMediumDocument(word_count) {
    if(word_count <= 3250 && word_count > 2275) return true;
    return false;
}
export function isLargeDocument(word_count) {
    if(word_count <= 5850 && word_count > 3250) return true;
    return false;
}
export function isExtraLargeDocument(word_count) {
    if(word_count <= 9100 && word_count > 5850) return true;
    return false;
}
export function isHugeDocument(word_count) {
    if(word_count > 9100) return true;
    return false;
}
const extra_to_receipt_column_map = {
    'ESL': 'receipt_esl',
    'ExtraEditing': 'receipt_esl2',
    'extraComments': 'receipt_extra',
    'Critiques': 'receipt_extra3',
    'Formatting': 'receipt_extra4',
    'Plagiarism': 'receipt_extra5',
    'gradeMyPaper': 'receipt_extra6',
    'CitationCorrection': 'receipt_extra7',
}
export function getReceiptPriceForExtra(submission, extra) {
    if(!extra_to_receipt_column_map[extra]) return 0;
    var key = extra_to_receipt_column_map[extra];
    if(!submission[key]) return 0;

    return submission[key];
}

export function docHasPlagExtra(extras) {
    if(extras.indexOf('Plagiarism') >= 0) return true;
    return false;
}
const EDITOR_EXTRA_DESCRIPTION = {
    'ESL': 'ESL (Optional, but for clients who self-identify as having written an ESL paper)',
    'ExtraEditing': 'Extra editing (Optional, meant to push you to edit more thoroughly)',
    'extraComments': 'Extra Comments (Leave more than 2 comments per page - helpful, GUIDING comments on how clients can improve certain sentences).',
    'Critiques': 'Critiques (Leave more than 2 comments per page - comment on the document further & outline any fundamental flaws or areas that need improvement. Be nice!)',
    'Formatting': 'Formatting (Currently this accounts for basic formatting on each page, headers, title page, font fixing, paragraph indenting)',
    'gradeMyPaper': 'Grade My Paper (Leave a New Comment at the end of the paper with a few sentences about what you think of their paper - be polite, do not insult the client. Include an approximate grade, such as A+, C- etc)',
    'CitationCorrection': 'Citation Correction (This accounts up to 10 citations from 1-10 pages and each page after 10 is an extra 1 citation paid)',
}
export function getEditorDescriptionPerExtra(extra) {
    if(!EDITOR_EXTRA_DESCRIPTION[extra]) return '';
    return EDITOR_EXTRA_DESCRIPTION[extra];
}
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


// WEBPACK FOOTER //
// ./src/util/displayUtils.js